import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Http } from "@angular/http";

@Injectable()
export class ConsultantsService {
  public searchData: any;
  constructor(private http: HttpClient, private _http: Http) { }

  getConsultants() {
    return this._http
      .get(`/api/internalconsultants/getConsultants`)
      .map(res => {
        const data = (<any>res).json();
        return data;
      });
  }
  getActiveConsultants() {
    return this.http.get(`/api/internalconsultants/getActiveConsultants`, {
      params: {},
      responseType: "json"
    });
  }

  updateConsultants(data) {
    return this._http.put(
      "/api/internalconsultants/updateConsultants",
      data,
      {}
    );
  }

  getConsultantDetailsById(id) {
    return this.http.get(`/api/internalconsultants/getConsultantDetailsById`, {
      params: { type: id },
      responseType: "json"
    });
  }

  getConsultantData(consultantId, testId, testDateId) {
    return this.http.get(
      `/api/internalconsultantlanding/getInternalConsultantData`,
      {
        params: {
          consultantId: consultantId,
          testId: testId,
          testDateId: testDateId
        },
        responseType: "json"
      }
    );
  }
  updateStatus(data) {
    return this._http.put("/api/internalconsultants/updateStatus", data, {});
  }

  addAnalyst(data: any) {
    return this._http.post("/api/internalconsultants/addAnalyst", data, {});
  }

  editAnalyst(data: any) {
    return this._http.put("/api/internalconsultants/editAnalyst", data, {});
  }
  setSearchResult(result) {
    this.searchData = result;
  }

  getSearchResult() {
    return this.searchData;
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/services/consultants.service.ts